import React, { Component } from 'react';
import './Footer.css';
import { lang } from '../../../il8n/lang';
import { Link } from 'react-router-dom';
import logoSM from './Images/logo-sm.png';
import { toggleInterstitial } from '../../../Actions/Index';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';


/**
 * The main application footer.
 * @constructor
 */


class Footer extends Component {



  constructor(props){
    super(props);

  }



  /**
  * Returns the current year.
  */
  getYear() {
    return new Date().getFullYear();
  }
  render() {
    let {gaToggle} = this.props;
    return (
    <footer className='footer'>
      <div className="wrap">
        <a className='footer__logo' href='https://www.spinmaster.com/' target='_blank' rel='noopener noreferrer'>
          <img src={logoSM} alt={lang.footer.brand} />
        </a>
        <div className='footer__links'>
          <a href={lang.footer.contactLink} target="_blank" rel="noreferrer noopener">
            {lang.footer.contactUs}
          </a>
          <a href={lang.footer.privacyLink} target="_blank" rel="noreferrer noopener">
            {lang.footer.privacy}
          </a>
            <a href={lang.footer.termsLink} target="_blank"  rel="noreferrer noopener " >
            {lang.footer.terms}
          </a>
          <a id="optanon">
            {lang.footer.cookies}
          </a>

          {/* <a href={lang.footer.supportLink} target="_blank">
            {lang.footer.support}
          </a> */}
        </div>
        <div className='footer__copyright'>
          <div className="copyright_spin">
          {`TM & © ${ this.getYear() } ${ lang.footer.copy }`}
          </div>
          <div className="socialbox-footer">
            <div className="socialbox__icons flex-row mod-centered">
              {lang.home.commingsoon.social.icons.map((icon,index)=>(
                <div className="socialbox__icons__icon" key={`${icon.type}_${index}`}>
                  <a onClick={() => {
                    this.props.dispatch(toggleInterstitial(true, icon.link ));
                    if(gaToggle.status){

                      ReactGA.event({
                        category: 'socialoutbound',
                        action: 'leave',
                        value: icon.type,
                      });
                    }
                  }} target="_blank">
                  
                    <img className="socialbox__icons__icon__static" src={`${icon.img}`} />
                    <img className="socialbox__icons__icon__hover" src={`${icon.img2}`} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>                
      </div>
      </div>
    </footer>
    );
  }
}

function mapStateToProps(state) {
  return { 
    lang: state.lang,
    gaToggle: state.gaToggle 
  };
}


export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/Navs/Footer/Footer.js